import { render, staticRenderFns } from "./RisProposal.vue?vue&type=template&id=06df1390&scoped=true"
import script from "./RisProposal.vue?vue&type=script&lang=js"
export * from "./RisProposal.vue?vue&type=script&lang=js"
import style0 from "./RisProposal.vue?vue&type=style&index=0&id=06df1390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06df1390",
  null
  
)

export default component.exports